const { filterFontsByRequiredActions, filterRequiredActionsByToggles, hasUpgradeFilterOption } = require('../../util/filter_variations.js');

/**
 * A service used to filter a set of variations based on the preferred actions for resolving entitlements.
 *
 * @ngInject
 * @deprecated
 * TODO: Remove this service after unified browse & search is released and flipper flag is removed.
 */
function FilterVariationsService() {

  return {
    filterFontsByRequiredActions: filterFontsByRequiredActions,
    filterRequiredActionsByToggles: filterRequiredActionsByToggles,
    hasUpgradeFilterOption: hasUpgradeFilterOption
  };
}

module.exports = FilterVariationsService;
